<template>
  <div id="page_pres">
    <ball></ball>
    <navpage class="heard_h" :title="'患者列表'"></navpage>
    <van-popup v-model="show" :style="{ height: '50%', width: '90%' }" round>
      <div class="pop_gauge">
        <div class="pop_gauge_cell">
          <div class="pop_gauge_cell_name">量表名</div>
          <div class="pop_gauge_cell_flag">状态</div>
          <div class="pop_gauge_cell_btn" style="color: white">按钮</div>
        </div>
        <div
          class="pop_gauge_cell"
          v-for="(item, index) in gaugelist"
          :key="idnex"
        >
          <div class="pop_gauge_cell_name">{{ item.name }}</div>
          <div
            v-bind:class="
              item.dataStatus == 1 ? 'gaugelist_flag_a' : 'gaugelist_flag_b'
            "
          >
            {{ item.dataStatus == 1 ? "已检测" : "未检测" }}
          </div>
          <div class="pop_gauge_cell_btn">
            <van-button type="info" @click="gonext(item)">查看</van-button>
          </div>
        </div>
      </div>
    </van-popup>
    <div v-if="showempty" class="empty">
      <van-empty
        image="https://account.kmmds.top/datainfo_pic/error.png"
        description="暂无预约挂号记录"
      />
    </div>
    <van-calendar
      color="#5b8df6"
      v-model="timeflag"
      :min-date="minDate"
      :max-date="new Date()"
      @confirm="(value) => onConfirm(value)"
    />
    <div class="body_pat" v-if="!showempty">
      <div class="body_pat_chlid">
        <div class="heard_keshi">
          <label
            >科室：<span>{{ deptName }}</span></label
          >
          <label @click="timeflag = true"
            >日期：<span>{{ time }}</span></label
          >
        </div>

        <div class="line"></div>
        <div>
          <span class="boby_tab">
            <span class="tr_tr">
              <span class="name_a"><label>姓名</label></span>
              <span class="name_b"><label>流水号</label></span>

              <span class="name_f"><label>处方开立</label></span>
              <span class="name_g"><label>测评结果</label></span>
            </span>
          </span>
          <div class="body_h">
            <span class="boby_tab" v-for="item in listdate" :key="item.index">
              <span class="tr" :index="item">
                <span class="name_a">{{ item.clientName }}</span>
                <span class="name_b">{{ item.clientId }}</span>

                <!-- <span v-if="item.opstatus==0" class="name_d" ><div class="name_d_a"><span @click="opstatus(item)">{{item.opstatus==0?"未开立":"已开立"}}</span></div></span> -->
                <span class="name_f"
                  ><div class="name_d_b">
                    <span @click="opstatus(item)">开立</span>
                  </div></span
                >
                <span class="name_f"
                  ><div class="name_e_a">
                    <span @click="evaluation(item)">查看</span>
                  </div></span
                >
                <!-- <span v-if="item.evaluation==1" class="name_d" ><div class="name_e_b"><span @click="evaluation(item)">{{item.evaluation==0?"未测评":"已测评"}}</span></div></span> -->
              </span>
            </span>
          </div>
        </div>
        <div class="line"></div>
        <div class="btn_pat">
          <van-button class="pat" type="info" @click="Accesspatient"
            >刷新</van-button
          >
          <van-button class="pat" type="info" @click="black">返回</van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import navpage from "@/components/nav.vue";
import { Dialog } from "vant";

export default {
  data() {
    return {
      minDate: new Date(),
      timeflag: false,
      showempty: false,
      // 保存患者真实信息
      listdate: {},
      time: "",
      deptName: "",
      show: false,
      pid: null,
      gaugelist: null,
    };
  },
  components: {
    navpage,
  },
  computed: {},
  mounted() {
    this.Accesspatient();
    this.nowtime();
    this.minDate=this.fun_data(-7);
  },
  methods: {
    fun_data(aa) {
      var date1 = new Date(),
        time1 =
          date1.getFullYear() +
          "-" +
          (date1.getMonth() + 1) +
          "-" +
          date1.getDate(); //time1表示当前时间
      var date2 = new Date(date1);
      date2.setDate(date1.getDate() + aa);
      var time2 =
        date2.getFullYear() +
        "-" +
        (date2.getMonth() + 1) +
        "-" +
        date2.getDate();
        console.log("time2",time2)
      return new Date(time2);
    },
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
    onConfirm(value) {
      //  console.log(new Date(value))
      this.time = this.formatDate(new Date(value));
      this.timeflag = false;
      this.Accesspatient();
    },
    gonext(item) {
      if (item.dataStatus == 1) {
        // this.$router.push("/gaugeresult");
        this.$router.push({
          path: "/gaugeresult",
          query: {
            pid: this.pid,
            questionary: item.id,
          },
        });
      } else {
        // this.$router.push("/gaugesubject");
        this.$toast.fail("患者的此量表尚未测试");
      }
    },
    nowtime() {
      // 获取当前时间
      var nowyear = new Date().getFullYear();
      var nowmonth = new Date().getMonth() + 1;
      var nowday = new Date().getDate();
      this.time = nowyear + "-" + nowmonth + "-" + nowday;
    },
    // 获取患者信息
    async Accesspatient() {
      try {
        this.$showLoad();
        let url = "/doc/queryallregbycondition";

        let beginDate = this.time + " 08:00:00";
        let data = { beginDate: beginDate };
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          data,
          (resultData) => {
            this.$hideLoad();
            this.listdate = resultData.data.data.data;
            this.deptName = this.listdate["0"].deptName;
            if (this.listdate.length == 0) {
              this.showempty = true;
            } else {
              this.showempty = false;
            }
          }
        );
      } catch (error) {}
    },
    black() {
      this.$router.push({ path: "/index" });
    },
    opstatus(hdata) {
      if (hdata.opstatus == 1) {
        Dialog.confirm({
          title: "温馨提示",
          message: "该患者已经开立过处方！是否查看处方详细？",
        })
          .then(() => {
            // on confirm
          })
          .catch(() => {
            // on cancel
          });
      } else {
        console.log(hdata);
        this.$router.push({ path: "/prescription", query: { list: hdata } });
      }
    },
    async evaluation(hdata) {
       this.pid=hdata.clinicId
      try {
        this.$showLoad();
        let url = "/gauge/queryallquestionaryinfo";
        let data = {
          id: hdata.clinicId,
        };
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          data,
          (data) => {
            this.$hideLoad();
            this.gaugelist = data.data.data.data;
             if (!data?.data) {
              this.$toast.fail("网络异常，请稍后重试");
            } else {
              this.show = true;
            }
          }
        );
      } catch (error) {}
    
    },
  },
};
</script>
<style>
#page_pres {
  font-family: "SimSun";
  height: 100vh;
}

.pop_gauge_cell {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 5vw;
  font-size: 16px;
  overflow-y:auto ;
  max-height: 60vh;
}
.pop_gauge_cell_name {
  width: 20vw;
}
.pop_gauge_cell_flag {
  width: 20vw;
}
.gaugelist_flag_a {
  width: 20vw;
  color: #2ecc71;
}
.gaugelist_flag_b {
  width: 20vw;
  color: red;
}
.heard_h {
  height: 5vh;
}
.heard_keshi {
  margin: 5px 0 0 0;
  display: flex;
  color: rgb(145, 142, 142);
  justify-content: space-between;
  font-size: 17px;
}
.line {
  margin: 10px 0;
  border: 1px solid rgb(145, 142, 142);
}
.boby_tab {
  font-size: 15px;
}
.body_pat {
  display: flex;
  justify-content: center;
  overflow-y: auto;
  height: 95vh;
}
.body_pat_chlid {
  width: 90%;
  margin: 10px 0;
}
.imge {
  margin: -2px 0;
  width: 15px;
  height: 15px;
}

.tr_tr {
  display: flex;
  flex-flow: 1;
  justify-content: space-between;
  align-items: center;
  text-align: center;
}
.body_h {
  height: 70vh;
  overflow-y: auto;
}
.tr {
  display: flex;
  flex-flow: 1;
  justify-content: space-between;
  align-items: center;
  height: 70px;
  text-align: center;
  margin: 5px 0;
  border-bottom: 1px solid rgb(180, 177, 177);
}
.name_a {
  width: 90px;
}
.name_b {
  width: 90px;
}

.name_c {
  width: 35px;
}
.name_d {
  width: 90px;
}

.name_d_a {
  width: 80px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(240, 132, 8);
  color: white;
  border-radius: 15px;
}
.name_d_b {
  width: 60px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #5b8df6;
  color: white;
  border-radius: 15px;
  margin-left: 15px;
}
.name_e_a {
  width: 60px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(240, 132, 8);
  color: white;
  border-radius: 15px;
}
.name_e_b {
  width: 80px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #5b8df6;
  color: white;
  border-radius: 15px;
}
.name_f {
  width: 90px;
}
.name_g {
  width: 90px;
}
.btn_pat {
  display: flex;
  justify-content: space-around;
  margin: 20px 0 0 0;
}
.pat {
  width: 90px;
}
</style>
